// Import UI Components
import { Icon } from '@geneui/components';
// Import Components
import CopyToClipboard from 'components/common/CopyToClipboard';
import TittleLink from 'components/common/TittleLink';
// Import Constants
import {
    SegmentTypesLabels,
    l,
    StateModesLabels,
    DataTableColumnsCustomTypes,
    CustomersTypesLabels,
    SegmentTypeIconClasses,
} from 'constants/common';
// Import Services
import { Helpers } from 'services';

const { customMomentWithoutTimezoneConversion } = Helpers;

const dataTableColumnsConfigs = (t, dateFormats) => {
    const { partnerDateTimeFormat } = dateFormats;
    return {
        columns: [
            {
                text: t(l.SegmentId),
                dataKey: 'SegmentId',
                sortable: true,
                colRenderer: (id) => <CopyToClipboard>{id}</CopyToClipboard>,
            },
            {
                text: t(l.Title),
                dataKey: 'Name',
                sortable: true,
                isPermanent: true,
                colRenderer: (Name: string, _index: number, { data: { TargetObject } }) => (
                    <div className="crm-list-column-title-icon-components">
                        <TittleLink name={Name} isClickable={false} />
                        {+TargetObject === +CustomersTypesLabels.NonCustomers && <Icon type="bc-icon-non-customer" />}
                    </div>
                ),
            },
            {
                text: t(l.Type),
                dataKey: 'Type',
                sortable: true,
                colRenderer: (type) => (
                    <div className="crm-object-type-label">
                        <Icon type={SegmentTypeIconClasses[type]} />
                        <span className="crm-object-type-text">{SegmentTypesLabels[type]}</span>
                    </div>
                ),
            },
            {
                text: t(l.State),
                dataKey: 'IsUsed',
                sortable: true,
                colRenderer: (IsUsed) => (
                    <div className={`crm-used-or-not-used-badge-cnt crm-used-or-not-used-label-${IsUsed}`}>
                        {IsUsed ? t(l.Used) : t(l.NotUsed)}
                    </div>
                ),
            },
            {
                text: t(l.User),
                dataKey: 'CreatorName',
                sortable: true,
            },
            {
                type: DataTableColumnsCustomTypes.Date,
                text: t(l.CreatedDate),
                dataKey: 'CreatedDate',
                sortable: true,
                formatter: (CreatedDate) => {
                    return customMomentWithoutTimezoneConversion(CreatedDate).format(partnerDateTimeFormat);
                },
            },
            {
                text: t(l.Mode),
                dataKey: 'State',
                sortable: true,
                colRenderer: (state) => (
                    <div className={`crm-mode-badge-cnt crm-cj-mode-label-${state}`}>{t(StateModesLabels[state])}</div>
                ),
            },
        ],
    };
};

export { dataTableColumnsConfigs };
